<div class="row justify-content-between">
  <ng-template [ngIf]="result_url" [ngIfElse]="no_url">
    <a [href]="result_url" target="_blank" class="col title content" [innerHTML]="result_title"></a>
  </ng-template>
  <ng-template #no_url>
    <span class="col title content" [innerHTML]="result_title"></span>
  </ng-template>
  <ng-template [ngIf]="date">
    <span class="col-auto date content pub-date text-end">
      <span class="label">Publication Date: </span>
      <span class="value">{{ date }}</span>
    </span>
  </ng-template>
</div>

<!-- New row for conditional Author display -->
<div class="row align-items-baseline g-0 author-row" *ngIf="author">
  <span class="col-auto author-label">
  {{ authorPlain.includes(',') ? 'Authors:' : 'Author:' }}
  </span>

  <!-- the author-col class on the column enables proper truncation -->
  <span
    class="col author-col author-value text-truncate"
    [innerHTML]="authorHtml"
    [attr.title]="authorPlain"
  ></span>
</div>
